module.exports = __webpack_public_path__ + "static/media/speaker_Colorado_GabeFierro.1eef62fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Colorado_GabeFierro.jpg
// module id = 240
// module chunks = 0